var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('segment-form',{attrs:{"title":_vm.$t('settings.segments.create.title')},on:{"submit":_vm.createSegment}})}
var staticRenderFns = []

export { render, staticRenderFns }